module.exports = __webpack_public_path__ + "media/images/about_us_2-58093eadd9bc52cfb2d98e7848e15c30.webp";